import merge from "lodash/merge";
// This required specifically used so an webpack plugin can write to the file
var version = require("../package.json").version; // eslint-disable-line prefer-destructuring
var configState = {
    version: version,
    mboxes: {
        fetchDebounceTime: 0,
        maxGlobalCount: 5,
        personalizationHost: null
    },
    launchDarkly: {
        personalizationFlagID: null,
        defaultProjectID: null,
        defaultUser: {
            key: "aLkdYinjkPdslfk4223ad"
        }
    },
    lpeCache: {
        defaultTimeoutMS: 3000,
        defaultDebounceTime: 0
    },
    adobeLaunchScriptSrc: null
};
export { version };
var config = function(options) {
    if (!options) {
        return configState;
    }
    return merge(configState, options, {
        version: version
    });
};
export default config;

//# sourceMappingURL=config.js.map